<fs-menu-simple
        [itemsList]='this.getLanguages()'
        [itemsListShort]='this.getLanguagesShort()'
        [showButtonShort]="true"
        [selectedItem]='selectedMenuLanguage'
        [leadingIcon]="'./libs/shared-ui/assets/icons/globe.svg'"
        (onSelect)="languageMenuPress($event)">
</fs-menu-simple>